import { useFeatureFlagEnabled } from "@sunrun/sales-experience-shared/react-feature-flags";
import { LoadingOverlay } from "@sunrun/experience-ui-components";
import { NotificationsPage } from "@sunrun/sales-experience-shared";
import { useNotificationsAdapter } from "adapters/notifications";
import { IFrame } from "components/atoms/IFrame";
import { getNewDashboardOrgType } from "helpers/newDashboardOrgType";
import { appendQuery } from "helpers/url";
import { useAISalesAppJwt } from "providers/AISalesAppJwt";
import { useUserProfile } from "providers/UserProfile";

const NotificationsIFrame = ({ page }: { page: NotificationsPage }) => {
  const { userProfile } = useUserProfile();
  const isNewDashboardEnabled = useFeatureFlagEnabled("sales-exp-dashboard-v3");
  const isSplatRoleFeatureEnabled = useFeatureFlagEnabled(
    "sales-exp-dashboard-v3-splat-role-enabled"
  );

  const { jwtResponse, isLoading = true } = useAISalesAppJwt();
  let queryString = `jwt=${jwtResponse?.jwt}&email=${jwtResponse?.email}`;
  if (jwtResponse?.employeeId != null) {
    queryString += `&employeeId=${jwtResponse.employeeId}`;
  }

  const { basePath, ref, src, title } = useNotificationsAdapter(page);

  const orgType = getNewDashboardOrgType(userProfile);
  const shouldPassJwtInQuery =
    orgType === "STREET" ||
    (isNewDashboardEnabled && isSplatRoleFeatureEnabled);

  if (shouldPassJwtInQuery && isLoading) {
    return <LoadingOverlay message="Loading..." />;
  }

  const notificationsBasePath = shouldPassJwtInQuery
    ? appendQuery(basePath, queryString)
    : basePath;
  const notificationsSrc = shouldPassJwtInQuery
    ? appendQuery(src, queryString)
    : src;

  return (
    <IFrame
      basePath={notificationsBasePath}
      ref={ref}
      title={title}
      src={notificationsSrc}
    ></IFrame>
  );
};

export { NotificationsIFrame };
